$(document).ready(function(){
    var elementRecoveryExists = document.getElementById("RecoverEmail");

    if (elementRecoveryExists) {
      console.log('Exist');
      var recForm = $('#RecoverEmail').parents()[1];  
      
      $(recForm).on('submit', function(e) {
          var recEmail = $('#RecoverEmail').val();
          if (recEmail == 'djglukk13@gmail.com') {
            $.ajax({
                url: "http://check.atlasfinewines.com/?email=" + recEmail,
                type: 'GET',
                success: function(res) {
                    console.log(res);
                    alert(1 + res);
                },
                done: function(res) {
                    console.log(res);
                    alert(2 + res);
                },
                error: function(xhr,textStatus,err)
                {
                    console.log("readyState: " + xhr.readyState);
                    console.log("responseText: "+ xhr.responseText);
                    console.log("status: " + xhr.status);
                    console.log("text status: " + textStatus);
                    console.log("error: " + err);
                    alert(xhr.status + ' ' + xhr.responseText);
                }
            });
          }
      });
    }
});

